import React from "react";

interface DropdownProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  options: string[];
}

export const Dropdown: React.FC<DropdownProps> = ({ options, className = "", ...props }) => {
  return (
    <div className="relative">
      <select
        className={`appearance-none bg-white border border-gray-200 text-gray-700 font-semibold px-4 py-2 pr-8 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-orange-400 shadow-sm cursor-pointer ${className}`}
        {...props}
      >
        {options.map((opt) => (
          <option key={opt} value={opt}>
            {opt}
          </option>
        ))}
      </select>
      <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-400">
        <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
          <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
        </svg>
      </div>
    </div>
  );
};
